module.exports = __webpack_public_path__ + "static/media/solspaces_greenhousebuild.59865b73.jpg";